import { FormlyFieldConfig } from 'ng-formly';
export const metafieldformfields: Array<FormlyFieldConfig> = [{
    key: 'fieldtype',
    type: 'select-component',
    templateOptions: {
        options: [{
            label: 'Checkbox',
            value: 'checkbox'
        }, {
            label: 'Multi Checkbox',
            value: 'multicheckbox'
        }, {
            label: 'Text Input',
            value: 'input-field'
        }, {
            label: 'Text Area',
            value: 'textarea-field'
        }, {
            label: 'Select',
            value: 'select-component'
        }, {
            label: 'Multi Select',
            value: 'select-component-multiple'
        }, {
            label: 'Repeated Section',
            value: 'repeatedsection'
        }],
        label: 'Field Type',
        required: true,
        default: 'active',
        placeholder: 'Select Fieldtype'
    }
},
{
    key: 'name',
    type: 'input-field',
    hideExpression: '!model.fieldtype',
    templateOptions: {
        type: 'text',
        placeholder: '',
        required: true,
        label: 'Field Name',
        description: 'Unique Value'
    }
},
{
    key: 'description',
    type: 'textarea-field',
    hideExpression: '!model.fieldtype',
    templateOptions: {
        placeholder: 'Brief Description of the field',
        required: true,
        label: 'Description'
    }
},
{
    key: 'label',
    type: 'input-field',
    hideExpression: '!model.fieldtype',
    templateOptions: {
        type: 'text',
        placeholder: '',
        required: true,
        label: 'Label'
    }
},
{
    type: 'repeatedsection',
    key: 'picklistcustomvalues',
    fieldArray: {

        templateOptions: {
            btnText: 'Add Product Type',
        },
        fieldGroup: [
            {
                type: 'input-field',
                key: 'label',
                className: 'col-md-4',
                templateOptions: {
                    type: 'text',
                    label: 'Product Name',
                    required: true,
                },
            },
            {
                type: 'input-field',
                key: 'value',
                className: 'col-md-4',
                templateOptions: {
                    type: 'text',
                    label: 'Value',
                    required: true,
                },
            }
        ]
    }
}];


// WEBPACK FOOTER //
// ./src/app/shared/formfields/metafield.ts